<p-panel>
  <div class="row">
    <app-reactive-form-builder
      #formbuilder
      (formChanges)="formChanges($event[0], $event[1])"
      (goBack)="goBack()"
      (afterSend)="undefined"
      [form]="form.formFields"
      [serverUrl]="''"
      [dropdownLoadTrigger]="dropdownLoadTrigger"
      [dropdownsFinalized]="dropdownsFinalized"
      [id]="getModel().id"
      [request]="getType() === FormRequestTypes.EDIT ? crmApiService.CRM.PUT : crmApiService.CRM.POST"
      [getRequest]="crmApiService.CRM.GET">
    </app-reactive-form-builder>
  </div>
</p-panel>